import React, { Component } from 'react';

import {
	Card,
	CardContent,
	CardHeader,
	Divider,
	Typography
} from 'material-ui';

import JobCardActions from './JobCardActions';

import Fade from 'material-ui/transitions/Fade';

export default class EmptyState extends Component {
	render() {
		const { subject, message, btnDestination, btnMsg } = this.props;
		const actions = [
			{
				color: 'default',
				text: btnMsg,
				link: btnDestination,
				raised: true,
				click: null
			}
		];
		return (
			<Fade in={true}>
				<Card className="card">
					<CardHeader title={subject} />
					<Divider light />
					<CardContent>
						<Typography align="left" color="inherit">
							{message}
						</Typography>
					</CardContent>
					<JobCardActions actions={actions} />
				</Card>
			</Fade>
		);
	}
}
// <CardActions>
//   <Link to={btnDestination}>
//     <Button raised >
//       {btnMsg}
//     </Button>
//   </Link>
// </CardActions>



// WEBPACK FOOTER //
// ./src/components/EmptyState.js